import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import { Button, FontAwesomeIcon } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import { unselectFromWishlist } from "areas/collection/store/actions"
import { IS_JEWLR } from "helpers/application"

const IconButton = styled(Button).attrs({
  variant: "text",
})`
  position: absolute;
  right: 8px;
  top: 10px;
  z-index: 1;
`

const Icon = styled(FontAwesomeIcon).attrs((props) => ({
  color: props.$wishlistAdded ? "wishlist" : "black",
  height: "22px",
  width: "22px",
}))``

const WishlistIcon = ({
  removeFromWishlist,
  wishlistAdded,
  wishlistLoading,
}) => {
  const [loading, setLoading] = useState(false)
  const wishlistName = IS_JEWLR() ? "wish list" : "collection"

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <IconButton
      aria-label={
        loading
          ? `Loading ${wishlistName}`
          : wishlistAdded
          ? `Remove from ${wishlistName}`
          : `Add to ${wishlistName}`
      }
      disabled={loading}
      onClick={(e) => {
        if (!loading) {
          setLoading(true)
          removeFromWishlist(e)
        }
      }}
    >
      {loading ? (
        <FontAwesomeIcon fontSize="22px" icon={faSpinner} spin />
      ) : (
        <Icon
          $wishlistAdded={wishlistAdded}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </IconButton>
  )
}

WishlistIcon.propTypes = {
  removeFromWishlist: PropTypes.func,
  wishlistAdded: PropTypes.bool,
  wishlistLoading: PropTypes.bool,
}

const mapStateToProps = (state, ownProps) => {
  const wishlistAdded = (state.wishlist.line_items || []).some(
    (line_item) =>
      line_item.style_code === ownProps.item.style_code ||
      line_item.rm_style_code === ownProps.item.rm_style_code
  )

  return {
    wishlistAdded,
    wishlistLoading: state.wishlist.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { wishlistAdded, wishlistLoading } = stateProps
  const { dispatch } = dispatchProps
  const { item } = ownProps

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    removeFromWishlist: (e) => {
      if (wishlistLoading) return null
      e.preventDefault()
      e.stopPropagation()
      const styleCode = item.rm_style_code || item.style_code
      if (wishlistAdded) {
        dispatch(unselectFromWishlist(styleCode, "Wishlist"))
      }
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(WishlistIcon)
